import React from "react";

export default function GameListing({ games = [] }) {
    return (
        <section className="games-listing">
            <style>{css}</style>
            <div className="games-grid">
                {games.map((game, index) => (
                    <div key={game.slug || game.sub_id || game.id || index}>
                    <article
                        className="game-card"
                        onClick={() => {
                            window.location.href = `/games/${game.slug || game.sub_id || game.id}`;
                        }}
                    >
                        <div className="gc-thumb">
                            <img src={game.image} alt={game.title} className="gc-thumb-img" />
                            <div className="gc-top">
                                <div className="gc-tag">{game.category}</div>
                                <div className="gc-votes">{game.votes ?? 0} ★</div>
                            </div>
                        </div>
                        <div className="gc-info">
                            <div className="gc-name">{game.title}</div>
                            <div className="gc-meta">{game.type}</div>
                        </div>
                    </article>
                    </div>
                ))}
                {games.length === 0 && <p className="games-empty">No games available.</p>}
            </div>
        </section>
    );
}

const css = `
.games-listing {
  padding: 12px 0 40px;
}
.games-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 16px;
}
.game-card {
  background: #101010;
  border: 1px solid rgba(255,255,255,.08);
  border-radius: 14px;
  overflow: hidden;
  cursor: pointer;
  transition: transform .22s ease, box-shadow .22s ease, border-color .22s ease;
}
.game-card:hover {
  transform: translateY(-3px);
  border-color: rgba(249,115,22,.6);
  box-shadow: 0 10px 24px rgba(0,0,0,.55);
}
.gc-thumb {
  position: relative;
  width: 100%;
  aspect-ratio: 4 / 3;
  overflow: hidden;
  background: #0b0b0b;
}
.gc-thumb-img {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform .28s ease, filter .28s ease;
}
.game-card:hover .gc-thumb-img {
  transform: scale(1.05);
  filter: brightness(.85) saturate(1.2);
}
.gc-top {
  position: absolute;
  inset: 10px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  z-index: 2;
}
.gc-tag {
  font-size: 10px;
  letter-spacing: 1.3px;
  text-transform: uppercase;
  background: rgba(249,115,22,.9);
  color: #0b0b0b;
  padding: 3px 7px;
  border-radius: 999px;
  font-weight: 700;
}
.gc-votes {
  font-size: 11px;
  color: #f59e0b;
  font-weight: 700;
  background: rgba(8,8,8,.6);
  padding: 3px 8px;
  border-radius: 999px;
}
.gc-info {
  padding: 10px 12px 12px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.gc-name {
  font-size: 13px;
  font-weight: 800;
  letter-spacing: .4px;
  text-transform: uppercase;
  color: #ffffff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.gc-meta {
  font-size: 11px;
  color: rgba(255,255,255,.65);
}
.games-empty {
  color: rgba(255,255,255,.7);
}
@media (max-width: 1200px) {
  .games-grid { grid-template-columns: repeat(4, 1fr); }
}
@media (max-width: 992px) {
  .games-grid { grid-template-columns: repeat(3, 1fr); }
}
@media (max-width: 700px) {
  .games-grid { grid-template-columns: repeat(2, 1fr); }
}
@media (max-width: 420px) {
  .games-grid { grid-template-columns: 1fr; }
}
`;
